export default __webpack_public_path__ + "static/media/offer.e0f5e37e.png";